import { useParams, Navigate } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";

const POLICIES = {
  shipping: {
    title: "Shipping Policy",
    sections: [
      { h: "Dispatch", p: "All orders are dispatched within 24–48 hours of confirmation, Monday through Saturday. Each parcel is packed by hand in our protective rigid casing." },
      { h: "Delivery timelines", p: "Metro cities: 2–4 business days. Rest of India: 4–7 business days. You will receive tracking details by email and SMS as soon as your order ships." },
      { h: "Shipping charges", p: "Complimentary shipping on all prepaid orders above ₹999. A flat fee of ₹79 applies to orders below this threshold." },
    ],
  },
  returns: {
    title: "Return Policy",
    sections: [
      { h: "Eligibility", p: "Due to the personal nature of fragrance, we accept returns only for products that arrive damaged, leaking or incorrect. Claims must be raised within 48 hours of delivery with unboxing photos or video." },
      { h: "Resolution", p: "Approved claims receive a free replacement or full refund to the original payment method within 5–7 business days, processed via our Shopify checkout partner." },
      { h: "How to raise a claim", p: "Write to contact@reserve30.in with your order number and supporting media. Our team responds within 24 hours." },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    sections: [
      { h: "What we collect", p: "We collect only the information needed to fulfil your order and improve your experience: name, contact details, shipping address and order history. Payments are processed securely by our checkout partner; we never store card details." },
      { h: "How we use it", p: "Your data is used for order fulfilment, support and — only with your consent — occasional launch announcements. We never sell or rent personal information to third parties." },
      { h: "Your rights", p: "You may request access, correction or deletion of your data at any time by writing to contact@reserve30.in." },
    ],
  },
};

export default function PolicyPage() {
  const { slug } = useParams();
  const policy = POLICIES[slug];
  if (!policy) return <Navigate to="/" replace />;

  return (
    <main data-testid={`policy-page-${slug}`} className="pt-24 md:pt-32">
      <Seo title={`${policy.title} — Reserve 30 Parfums`} description={policy.sections[0].p.slice(0, 155)} />
      <div className="max-w-[900px] mx-auto px-5 md:px-10 pb-28">
        <Reveal>
          <p className="overline-label">Policies</p>
          <h1 className="font-serif-brand text-5xl md:text-6xl font-light mt-4">{policy.title}</h1>
        </Reveal>
        <div className="mt-14 space-y-12">
          {policy.sections.map((s, i) => (
            <Reveal key={s.h} delay={i * 0.08}>
              <div className="border-t border-black/10 pt-8">
                <h2 className="font-serif-brand text-2xl font-light">{s.h}</h2>
                <p className="mt-3 text-sm md:text-base text-black/60 leading-relaxed">{s.p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </main>
  );
}
